import React from "react";
import * as d3 from "d3";

export const markerDeps = [
  {
    id: "Dark",
    color: "#000"
  },
  {
    id: "Light",
    color: "#fff"
  }
];

export const dataLayerConfig = {
  perceivedThreat: {
    adjustGridToMatchData: true
  },
  heatMap: {
    adjustGridToMatchData: false
  }
};

export const lineStyles = {
  solid: "none",
  dashed: "5, 5",
  dotted: "2, 2"
};

export const curveOptionsX = {
  curveBasisX: "curveBasis",
  curveCardinalX: "curveCardinal",
  curveStepX: "curveStepBefore"
};

export const curveOptionsY = {
  curveBasisY: "curveBasis",
  curveCardinalY: "curveCardinal",
  curveStepY: "curveStepAfter"
};

export const curveOptions = {
  ...curveOptionsX,
  ...curveOptionsY
};

const americanFootballNumbers = {
  10: (
    <g transform="translate(-10, 4)">
      <path d="M21.9873935,6.35359899 C21.6526475,10.2530317 17.697569,12.226943 14.4369701,10.1797881 C13.6681051,9.69705706 13.1234129,9.02272284 12.8266019,8.16704756 C12.1925966,6.33928197 12.1797069,4.49244146 12.8194086,2.66912835 C13.3100855,1.27056498 14.2981446,0.30936369 15.7612516,0.109780156 C16.8014722,-0.0321165038 17.9249816,-0.0637391353 18.9338208,0.180825222 C20.8705033,0.650317561 21.6915421,2.1984688 21.9433029,4.0678829 C22.0417123,4.79864703 21.9806555,5.5512716 21.9873935,6.35359899 M18.0287142,9.24809715 C18.2226088,8.92870666 18.5192476,8.63174795 18.5933622,8.28620793 C19.0041953,6.37077201 19.0031003,4.43900246 18.6053209,2.52144296 C18.4310539,1.68138613 17.9552967,1.31677402 17.2225458,1.30767888 C16.4869323,1.29854822 15.9908829,1.65903584 15.8136141,2.48667743 C15.4082681,4.37917043 15.3873362,6.29258931 15.7822204,8.18633075 C16.0312006,9.38039838 16.7838499,9.72913891 18.0287142,9.24809715 Z"></path>
      <path d="M1.82185316,10.6193754 C1.17931296,10.6193754 0.603482844,10.6193754 0,10.6193754 C0,10.1052774 0,9.66652897 0,9.15795979 C0.362481355,9.15795979 0.691912321,9.16064415 1.02128429,9.15735158 C1.55798342,9.15198721 1.85714494,8.90198187 1.85644413,8.33480591 C1.85430285,6.60072039 1.85566645,4.8666307 1.85566645,3.07311232 C1.25773567,3.07311232 0.687161445,3.07311232 0.0659950173,3.07311232 C0.0659950173,2.55280121 0.0659950173,2.09113836 0.0659950173,1.61596832 C0.430377367,1.56592683 0.819925262,1.56624842 1.17089905,1.44901831 C1.51845169,1.33293114 1.99851403,1.17599848 2.12092948,0.901175968 C2.50045152,0.049151052 3.17917137,0.166201252 3.85666134,0.173175913 C4.16571365,0.176357442 4.47482482,0.173716608 4.87063058,0.173716608 C4.87063058,0.465965127 4.87063058,0.704177273 4.87063058,0.942389148 C4.87063058,3.22074349 4.8704466,5.49909729 4.87070086,7.77745152 C4.87084693,9.09003416 4.92155255,9.14144976 6.2286578,9.15900566 C6.35641339,9.16072062 6.48420998,9.15923425 6.64189718,9.15923425 C6.64189718,9.65685735 6.64189718,10.1011502 6.64189718,10.6193754 C5.0522435,10.6193754 3.47040343,10.6193754 1.82185316,10.6193754 Z"></path>
    </g>
  ),
  20: (
    <g transform="translate(-12, 4)">
      <path d="M4.47011327,5.17486071 C4.67699672,5.03062296 4.8502967,4.9224681 5.00713635,4.79471003 C5.75294519,4.18719402 6.02220829,3.42807922 5.77043235,2.66596527 C5.52144835,1.91231626 4.81133509,1.44125397 3.87359893,1.40768269 C2.8497471,1.37102853 2.06872076,1.80209291 1.70720622,2.64638956 C1.87293298,2.63829405 2.0132845,2.62703246 2.15375551,2.62533287 C2.78989536,2.61763565 3.30021175,3.0258957 3.40717721,3.62497332 C3.52519053,4.28593919 3.20969204,4.8617789 2.6071971,5.085075 C1.17330763,5.61650188 -0.101080226,4.69033681 0.00633632535,3.17986494 C0.0838881748,2.08933729 0.647418636,1.26557638 1.60895429,0.766377881 C3.44217429,-0.185370714 5.34980516,-0.251725669 7.24056316,0.573315737 C8.47368192,1.11139229 9.08470117,2.12526209 9.08152477,3.4569535 C9.07838365,4.7735504 8.45490172,5.74012108 7.21374202,6.2287291 C6.23005644,6.61597687 5.19000518,6.86276708 4.19924419,7.234638 C3.49442897,7.49918031 2.82995342,7.86800029 2.14747532,8.19028177 C2.1709142,8.24039941 2.19435307,8.29051611 2.21779182,8.34063389 C2.85865288,8.23556902 3.50006161,8.04393379 4.1402344,8.04785714 C4.90098273,8.05251669 5.66326021,8.20938752 6.42021567,8.3289273 C7.57285236,8.51095276 7.75927592,8.38674524 7.9375963,7.24594723 C7.94733149,7.18366432 7.98395634,7.12545936 8.01952944,7.03677594 C8.46277426,7.03677594 8.90733515,7.03677594 9.34782754,7.03677594 C9.89618254,9.75433179 8.03252632,11.4599648 5.31538382,10.7357598 C4.72735237,10.5790302 4.16514819,10.3305733 3.58220157,10.152459 C2.8301853,9.92268899 2.11084311,9.61494698 1.46477992,10.5042648 C1.28350658,10.7537916 0.543837607,10.609734 0.04268884,10.6475411 C-0.168891842,8.89708469 0.415455042,7.57446292 1.83658564,6.66186519 C2.66900386,6.12731625 3.56277382,5.68546265 4.47011327,5.17486071 Z"></path>
      <path d="M23.9872195,6.40104239 C23.6478539,10.2606588 19.6381943,12.2144149 16.3325983,10.1881632 C15.5531228,9.71036113 15.0009137,9.04291239 14.7000067,8.19597423 C14.0572519,6.38687156 14.0441843,4.55888875 14.6927141,2.75419309 C15.1901625,1.36991014 16.191857,0.418523475 17.6751553,0.220977845 C18.7297312,0.0805300609 19.8687453,0.0492303214 20.8915068,0.291297485 C22.854916,0.755995942 23.6872853,2.28833935 23.9425205,4.13866526 C24.0422879,4.86196772 23.9803885,5.6069074 23.9872195,6.40104239 M19.9739094,9.26598545 C20.1704799,8.94985619 20.4712123,8.65592966 20.5463497,8.31391788 C20.9628524,6.41804006 20.9617424,4.50599539 20.5584734,2.60801568 C20.3818016,1.77653649 19.8994788,1.41564736 19.1566157,1.40664509 C18.4108506,1.39760766 17.9079555,1.75441441 17.7282403,2.57360514 C17.3173005,4.4467743 17.2960797,6.34065567 17.6964134,8.21506052 C17.9488296,9.39693579 18.7118657,9.74211539 19.9739094,9.26598545 Z"></path>
    </g>
  ),
  30: (
    <g transform="translate(-12, 4)">
      <path d="M23.9871468,6.39917807 C23.6458518,10.2603591 19.6133948,12.2149072 16.2890045,10.1878341 C15.5050972,9.70983835 14.9497485,9.04211904 14.6471306,8.19483754 C14.0007214,6.3850015 13.9875795,4.55627766 14.6397965,2.75085043 C15.1400732,1.36600632 16.147463,0.41423399 17.6391947,0.21660828 C18.6997665,0.0761035623 19.8452566,0.0447911344 20.8738331,0.286956427 C22.8484055,0.751843257 23.6855073,2.28480784 23.9421937,4.13588383 C24.0425284,4.85947949 23.980277,5.60472115 23.9871468,6.39917807 M19.9510186,9.26528253 C20.1487067,8.94902511 20.451149,8.65497943 20.5267136,8.31282901 C20.9455844,6.41618263 20.944468,4.50336287 20.5389063,2.60461376 C20.3612299,1.7727975 19.8761648,1.41176208 19.1290781,1.40275616 C18.3790729,1.39371507 17.8733186,1.75066646 17.6925816,2.57018927 C17.2793053,4.44411776 17.2579639,6.33876687 17.6605737,8.21393157 C17.9144251,9.39628594 18.6817995,9.74160548 19.9510186,9.26528253 Z"></path>
      <path d="M0.0096018332,8.45151436 C-0.0634686134,7.23454863 0.277161664,6.63596301 1.14650145,6.37845236 C2.03707182,6.11465288 2.91673951,6.50484575 3.16086298,7.27195831 C3.41277428,8.0635463 3.00733585,8.61330999 1.95812666,8.90283237 C2.59752178,9.55375199 3.96118612,9.69686533 5.05729503,9.22808282 C5.82233004,8.90089353 6.15052501,8.3488253 6.11130433,7.45508887 C6.07005777,6.51510154 5.5294169,6.00034565 4.47911845,5.91469847 C4.25580111,5.89648834 4.02961539,5.91204568 3.76270788,5.91204568 C3.76270788,5.45271292 3.76270788,5.03878002 3.76270788,4.54790393 C4.01399398,4.51743204 4.27688317,4.49299498 4.53718419,4.45258064 C5.29583439,4.33479243 5.70336761,3.94287526 5.79905261,3.24961427 C5.89650015,2.54359158 5.57962383,1.95559781 4.93705933,1.65009909 C3.99334666,1.20142313 2.74114122,1.3448439 2.1729977,1.89029573 C2.55331697,2.18865596 3.04519544,2.43135436 3.29218947,2.82251047 C3.43814006,3.05364521 3.29791155,3.58595729 3.10724401,3.86554649 C2.76405487,4.36878678 2.16695159,4.46445428 1.57504576,4.39089164 C0.961737802,4.31466857 0.50948543,4.00045606 0.321815872,3.39998116 C0.0816207041,2.63143994 0.242327184,1.90752717 0.790072193,1.34280168 C1.15502079,0.966539979 1.62685,0.621079614 2.11909648,0.444458855 C3.87754115,-0.186481483 5.66156916,-0.140521666 7.39578523,0.549488443 C8.61636106,1.03513159 9.11185024,1.84310551 9.01783556,2.98653277 C8.93395656,4.0066548 8.36990234,4.56192289 7.06693588,4.91303036 C7.01376837,4.92735703 6.97043757,4.97672989 6.84594326,5.06259322 C7.1769815,5.17924809 7.44216004,5.26958531 7.70505979,5.36589037 C8.6971252,5.72930377 9.28844146,6.41356877 9.35173808,7.46090876 C9.41733022,8.54625339 9.14697943,9.53710494 8.1286471,10.123377 C7.63067648,10.4100675 7.0463868,10.6087779 6.47593944,10.7078064 C4.9582147,10.9712781 3.43053432,10.9773048 1.93460056,10.5472698 C0.890590745,10.2471492 0.186479556,9.61140193 0.0096018332,8.45151436 Z"></path>
    </g>
  ),
  40: (
    <g transform="translate(-13, 4)">
      <path d="M24.9869251,6.35359899 C24.639743,10.2530317 20.5377287,12.226943 17.1559948,10.1797881 C16.3585656,9.69705706 15.7936375,9.02272284 15.4857996,8.16704756 C14.8282403,6.33928197 14.8148717,4.49244146 15.4783391,2.66912835 C15.9872452,1.27056498 17.0120118,0.30936369 18.5294749,0.109780156 C19.6083409,-0.0321165038 20.77359,-0.0637391353 21.8199088,0.180825222 C23.8285412,0.650317561 24.6800825,2.1984688 24.9411966,4.0678829 C25.0432619,4.79864703 24.9799368,5.5512716 24.9869251,6.35359899 M20.8811763,9.24809715 C21.0822744,8.92870666 21.3899336,8.63174795 21.4668017,8.28620793 C21.8928977,6.37077201 21.8917621,4.43900246 21.4792047,2.52144296 C21.2984635,1.68138613 20.8050313,1.31677402 20.0450579,1.30767888 C19.2821155,1.29854822 18.7676373,1.65903584 18.5837827,2.48667743 C18.1633777,4.37917043 18.1416681,6.29258931 18.5512227,8.18633075 C18.8094529,9.38039838 19.5900639,9.72913891 20.8811763,9.24809715 Z"></path>
      <path d="M8.37298317,4.43903459 C8.37298317,4.97742278 8.37298317,5.44824679 8.37298317,5.98383754 C8.96149654,5.98383754 9.50676962,5.98383754 10.0957509,5.98383754 C10.0957509,6.48455662 10.0957509,6.92202665 10.0957509,7.42848457 C9.55994175,7.42848457 9.01572779,7.42848457 8.48919541,7.42848457 C8.1604774,8.77294515 8.30636595,8.93112704 10.1084771,9.23957159 C10.1084771,9.65611572 10.1084771,10.07892 10.1084771,10.559819 C7.87941067,10.559819 5.64529539,10.559819 3.37117652,10.559819 C3.37117652,10.1281521 3.37117652,9.68814686 3.37117652,9.2993628 C3.96540225,9.15690986 4.63169396,9.13902003 5.09371455,8.83109584 C5.35418199,8.65749927 5.27809652,8.00606457 5.36698484,7.49266263 C3.53764318,7.49266263 1.81012007,7.49266263 0.0727589416,7.49266263 C-0.101021493,6.48776431 -0.00373699725,5.70323578 0.810218932,4.96236359 C2.31632537,3.59149169 3.70540269,2.09754169 5.11758472,0.631484769 C5.44904622,0.287375536 5.78364257,0.139229163 6.26476944,0.16613536 C6.93329843,0.203522191 7.60569801,0.175538672 8.37298317,0.175538672 C8.37298317,1.59665815 8.37298317,2.98406422 8.37298317,4.43903459 M2.76377792,5.99590175 C3.59089182,5.99590175 4.41800572,5.99590175 5.25186559,5.99590175 C5.25186559,4.89893177 5.25186559,3.87781467 5.25186559,2.74130755 C4.17854176,3.83567846 3.18462098,4.84909093 2.10534229,5.94953693 C2.37599676,5.97318431 2.50570092,5.98451707 2.76377792,5.99590175 Z"></path>
    </g>
  ),
  50: (
    <g transform="translate(-12, 4)">
      <path d="M23.9870459,6.37833911 C23.6430707,10.2570089 19.5789478,12.22041 16.2284518,10.1841554 C15.4383886,9.70399468 14.8786789,9.033251 14.5736846,8.18213182 C13.9221992,6.36409833 13.9089542,4.52709146 14.566293,2.71348672 C15.0704982,1.32237009 16.0857988,0.366286795 17.5892447,0.167765958 C18.658145,0.0266248378 19.8126303,-0.00482941664 20.849284,0.23843274 C22.8393623,0.705425232 23.6830377,2.24533323 23.9417397,4.10479349 C24.0428623,4.83166662 23.9801221,5.58028378 23.9870459,6.37833911 M19.9192229,9.25742529 C20.1184634,8.93973542 20.4232807,8.64435788 20.4994387,8.30065772 C20.9215988,6.39542069 20.9204736,4.473937 20.5117271,2.56658768 C20.3326555,1.7310038 19.8437813,1.3683331 19.0908279,1.35928639 C18.334933,1.35020434 17.8252071,1.70877251 17.6430508,2.53200727 C17.2265292,4.41442355 17.2050202,6.31765429 17.6107916,8.20131234 C17.8666364,9.38902207 18.6400368,9.7359057 19.9192229,9.25742529 Z"></path>
      <path d="M2.68579353,3.56111238 C4.11013146,2.98738359 5.49560243,3.03108502 6.84683755,3.52291278 C8.29174049,4.04883586 9.10555885,5.12313784 9.22904164,6.62444611 C9.35335047,8.13579284 8.80052657,9.38773916 7.40817393,10.1345197 C5.45831149,11.1803129 3.43276714,11.1356046 1.44761534,10.2341048 C0.386936773,9.75242559 -0.112059896,8.74092841 0.0211280638,7.68988479 C0.123637201,6.88092548 0.769770475,6.30496289 1.59997765,6.28249817 C2.52272311,6.25752912 3.10509641,6.65069726 3.23537248,7.38657474 C3.37243315,8.16078238 3.0458877,8.55471597 1.96030367,8.87317656 C2.74227981,9.59760052 3.62602769,9.60313376 4.5412466,9.33574111 C5.45378549,9.06913252 5.80598663,8.35088603 5.93285343,7.50610169 C5.98244962,7.17583883 5.97509596,6.83199559 5.95022406,6.4974186 C5.8366319,4.96946109 4.15596444,4.08633784 2.87311211,4.97126064 C2.14790879,5.47151071 1.45817169,5.29031946 0.664227248,5.35263405 C0.797461603,3.54494285 0.925731661,1.80455183 1.0587343,0 C1.66987334,0.0573553069 2.23516268,0.162046341 2.79869884,0.153718965 C4.56678009,0.127593239 6.33408183,0.0538545159 8.10204099,0.0134758674 C8.30977285,0.00873141158 8.66905796,0.0542929408 8.69784054,0.150660915 C8.7593545,0.356635649 8.73453314,0.69354056 8.59478374,0.829842015 C8.22910152,1.18650544 7.82415618,1.55499542 7.36088714,1.75682272 C5.81441917,2.43055945 4.19357147,2.61549343 2.3934838,2.17994278 C2.47938056,2.69742426 2.55314923,3.14182338 2.68579353,3.56111238 Z"></path>
    </g>
  )
};

const americanFootballNumbersRange = {
  10: americanFootballNumbers[10],
  20: americanFootballNumbers[20],
  30: americanFootballNumbers[30],
  40: americanFootballNumbers[40],
  50: americanFootballNumbers[50],
  60: americanFootballNumbers[40],
  70: americanFootballNumbers[30],
  80: americanFootballNumbers[20],
  90: americanFootballNumbers[10]
};

export const playingAreaConfig = {
  americanFootball: {
    fillColor: "#34a853",
    heatMapBandwidth: 20,
    heatMapDomain: [0, 0.001, 0.0025],
    height: 320, // rounding this up as the proper ratio is 1 (width) : 0.444 (height) which returns 319.68 a football field is 53.3 yards wide
    padding: 20,
    strokeColor: "#FFFFFF",
    width: 720, // a football field is 120 yards long

    full: ({ height, strokeColor, strokeWidth, width }) => (
      <g>
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <line
          x1={width / 2}
          y1={0}
          x2={width / 2}
          y2={height}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        {d3.range(2).map((i) => (
          <g
            key={i}
            transform={`translate(0, ${
              i === 0 ? height / 4 : height - height / 4
            })`}
          >
            {d3.range(10).map((j) => {
              return j !== 0 ? (
                <g
                  key={j}
                  fill={strokeColor}
                  transform={`translate(${
                    width * 0.15 + ((width / 2 - width * 0.15) / 5) * j
                  }, 0) ${i === 0 ? "rotate(180)" : ""}`}
                >
                  {americanFootballNumbersRange[j * 10]}
                  {((i === 0 && j > 5) || (i === 1 && j < 5)) && (
                    <polygon
                      points={`0,0 ${4},${4} ${4},${-4}`}
                      transform={`translate(${-18}, ${10})`}
                    />
                  )}
                  {((i === 0 && j < 5) || (i === 1 && j > 5)) && (
                    <polygon
                      points={`0,0 ${-4},${-4} ${-4},${4}`}
                      transform={`translate(${18}, ${10})`}
                    />
                  )}
                </g>
              ) : null;
            })}
          </g>
        ))}
      </g>
    ),
    half: ({
      fillColor,
      fullPitchView,
      height,
      strokeColor,
      strokeWidth,
      width
    }) => (
      <g>
        {!fullPitchView && (
          <rect
            x={0}
            y={0}
            width={width / 2}
            height={height}
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        )}
        <g>
          {d3.range(10).map((i) => (
            <line
              key={i}
              x1={width * 0.15 + ((width / 2 - width * 0.15) / 10) * i}
              y1={0}
              x2={width * 0.15 + ((width / 2 - width * 0.15) / 10) * i}
              y2={height}
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
          ))}
        </g>
        <g>
          <rect
            x={0}
            y={0}
            width={width * 0.15}
            height={height}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
          {d3.range(2).map((i) => (
            <circle
              key={i}
              width={width / 2}
              cy={i === 0 ? height * 0.442 : height - height * 0.442}
              r={height * 0.01}
              fill={strokeColor}
            />
          ))}
        </g>
        <g>
          {d3.range(2).map((i) => (
            <g key={i}>
              {d3.range(50).map((j) => (
                <line
                  key={j}
                  x1={width * 0.15 + ((width / 2 - width * 0.15) / 50) * j}
                  y1={i === 0 ? 0 : height}
                  x2={width * 0.15 + ((width / 2 - width * 0.15) / 50) * j}
                  y2={i === 0 ? height * 0.02 : height - height * 0.02}
                  stroke={strokeColor}
                  strokeWidth={strokeWidth}
                />
              ))}
            </g>
          ))}
          {d3.range(2).map((i) => (
            <g key={i}>
              {d3.range(50).map((j) => (
                <line
                  key={j}
                  x1={width * 0.15 + ((width / 2 - width * 0.15) / 50) * j}
                  y1={i === 0 ? height * 0.432 : height - height * 0.432}
                  x2={width * 0.15 + ((width / 2 - width * 0.15) / 50) * j}
                  y2={i === 0 ? height * 0.452 : height - height * 0.452}
                  stroke={strokeColor}
                  strokeWidth={strokeWidth}
                />
              ))}
            </g>
          ))}
        </g>
        {!fullPitchView && (
          <>
            {d3.range(2).map((i) => (
              <g
                key={i}
                transform={`translate(0, ${
                  i === 0 ? height / 4 : height - height / 4
                })`}
              >
                {d3.range(5).map((j) => {
                  return j !== 0 ? (
                    <g
                      key={j}
                      fill={strokeColor}
                      transform={`translate(${
                        width * 0.15 + ((width / 2 - width * 0.15) / 5) * j
                      }, 0) ${i === 0 ? "rotate(180)" : ""}`}
                    >
                      {americanFootballNumbersRange[j * 10]}
                      {((i === 0 && j > 5) || (i === 1 && j < 5)) && (
                        <polygon
                          points={`0,0 ${4},${4} ${4},${-4}`}
                          transform={`translate(${-18}, ${10})`}
                        />
                      )}
                      {((i === 0 && j < 5) || (i === 1 && j > 5)) && (
                        <polygon
                          points={`0,0 ${-4},${-4} ${-4},${4}`}
                          transform={`translate(${18}, ${10})`}
                        />
                      )}
                    </g>
                  ) : null;
                })}
              </g>
            ))}
          </>
        )}
      </g>
    )
  },
  soccer: {
    fillColor: "#34a853",
    heatMapBandwidth: 20,
    heatMapDomain: [0, 0.001, 0.0025],
    height: 480, // a soccer pitch is 80 yards wide
    padding: 20,
    strokeColor: "#FFFFFF",
    width: 720, // a soccer pitch is 120 yards long
    full: ({ height, isLandscape, strokeColor, strokeWidth, width }) => (
      <g>
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <line
          x1={width / 2}
          y1={0}
          x2={width / 2}
          y2={height}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={width / 2}
          cy={height / 2}
          r={width * 0.0833}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={width / 2}
          cy={height / 2}
          r={width * 0.0025}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
      </g>
    ),
    half: ({
      fillColor,
      fullPitchView,
      height,
      strokeColor,
      strokeWidth,
      width
    }) => (
      <>
        <rect
          x={-(width * 0.0225)}
          y={height / 2 - height * 0.05}
          width={width * 0.0225}
          height={height * 0.1}
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <path
          d={d3.arc()({
            innerRadius: 0,
            outerRadius: width * 0.00833,
            startAngle: Math.PI / 2,
            endAngle: Math.PI
          })}
          transform={`translate(0, 0)`}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <path
          d={d3.arc()({
            innerRadius: 0,
            outerRadius: width * 0.00833,
            startAngle: 0,
            endAngle: Math.PI / 2
          })}
          transform={`translate(0, ${height})`}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <defs>
          <mask id="areaCircleMask">
            <rect
              x={width * 0.15}
              y={height / 2 - height * 0.275}
              width={width * 0.15}
              height={height * 0.55}
              fill="white"
            />
          </mask>
        </defs>
        <g mask="url(#areaCircleMask)">
          <path
            d={d3.arc()({
              innerRadius: 0,
              outerRadius: width * 0.0833,
              startAngle: 0,
              endAngle: Math.PI / 1
            })}
            transform={`translate(${width * 0.1}, ${height / 2})`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
        <rect
          x={0}
          y={height / 2 - height * 0.275}
          width={width * 0.15}
          height={height * 0.55}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          id="rect"
        />
        <rect
          x={0}
          y={height / 2 - height * 0.125}
          width={width * 0.05}
          height={height * 0.25}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={width * 0.1}
          cy={height / 2}
          r={width * 0.0025}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        {!fullPitchView && (
          <g>
            <rect
              x={0}
              y={0}
              width={width / 2}
              height={height}
              fill="none"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
            <path
              d={d3.arc()({
                innerRadius: 0,
                outerRadius: width * 0.0833,
                startAngle: 0,
                endAngle: -Math.PI
              })}
              transform={`translate(${width / 2}, ${height / 2})`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
            <path
              d={d3.arc()({
                innerRadius: 0,
                outerRadius: width * 0.0025,
                startAngle: 0,
                endAngle: -Math.PI
              })}
              transform={`translate(${width / 2}, ${height / 2})`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
          </g>
        )}
      </>
    )
  },
  basketball: {
    fillColor: "#FDCB9E",
    heatMapBandwidth: 5,
    heatMapDomain: [0, 0.002, 0.004],
    height: 384, // a basketball court is 16.4 yards wide
    homeTeamLogoSize: 0.1285,
    padding: 20,
    strokeColor: "#000000",
    width: 720, // a basketball court is 30.62 yards long
    full: ({
      fillColor,
      height,
      isLandscape,
      strokeColor,
      strokeWidth,
      width
    }) => (
      <g>
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <line
          x1={width / 2}
          y1={0}
          x2={width / 2}
          y2={height}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={width / 2}
          cy={height / 2}
          r={height * 0.1285}
          fill={fillColor}
        />
        <circle
          cx={width / 2}
          cy={height / 2}
          r={height * 0.1285}
          fill={"none"}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
      </g>
    ),
    half: ({
      fillColor,
      fullPitchView,
      height,
      strokeColor,
      strokeWidth,
      width
    }) => (
      <>
        <g>
          {!fullPitchView && (
            <rect
              x={0}
              y={0}
              width={width / 2}
              height={height}
              fill="none"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
          )}
          <rect
            x={0}
            y={height * 0.34}
            width={width * 0.2067}
            height={height * 0.32}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            id="rect"
          />
          <rect
            x={0}
            y={height / 2 - height * 0.1285}
            width={width * 0.2067}
            height={height * 0.257}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
        <g>
          <path
            d={d3.arc()({
              innerRadius: width * 0.04464,
              outerRadius: width * 0.04464,
              startAngle: 0,
              endAngle: Math.PI / 1
            })}
            transform={`translate(${width * 0.05625}, ${height / 2})`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
          <circle
            cx={width * 0.05625}
            cy={height / 2}
            r={height * 0.0152}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
          <rect
            x={width * 0.0325}
            y={height / 2 - height * 0.06}
            width={width * 0.0075}
            height={height * 0.1201}
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
          <line
            x1={width * 0.05}
            y1={height / 2}
            x2={width * 0.0325 + width * 0.0075}
            y2={height / 2}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
          <path
            d={`M 0 ${height * 0.06} L ${width * 0.1487} ${height * 0.06} A ${
              width * 0.2527
            } ${width * 0.2527} 0 0 1 ${width * 0.1487} ${
              height - height * 0.06
            } L 0 ${height - height * 0.06} Z`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
        <g>
          <path
            d={d3.arc()({
              innerRadius: height * 0.1285,
              outerRadius: height * 0.1285,
              startAngle: 0,
              endAngle: Math.PI / 1
            })}
            transform={`translate(${width * 0.2067}, ${
              height / 2
            }) scale(-1, 1)`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeDasharray="10, 10"
          />
          <path
            d={d3.arc()({
              innerRadius: height * 0.1285,
              outerRadius: height * 0.1285,
              startAngle: 0,
              endAngle: Math.PI / 1
            })}
            transform={`translate(${width * 0.2067}, ${height / 2})`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
        <g>
          <path
            d={d3.arc()({
              innerRadius: 0,
              outerRadius: height * 0.1285,
              startAngle: 0,
              endAngle: -Math.PI
            })}
            transform={`translate(${width / 2}, ${height / 2})`}
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </>
    )
  }
};
